import { render, staticRenderFns } from "./HomeworkStatisticsCard.vue?vue&type=template&id=c123a450&scoped=true&"
import script from "./HomeworkStatisticsCard.vue?vue&type=script&lang=js&"
export * from "./HomeworkStatisticsCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkStatisticsCard.vue?vue&type=style&index=0&id=c123a450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c123a450",
  null
  
)

export default component.exports